<template>
 <div>
   <div class="error-logo">
     <div class="symbol">
       &times;
     </div>
   </div>
 </div>
</template>

<script>
export default {
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<style scoped>
.error-logo {
 width: 11rem;
 height: 11rem;
 border-radius: 50%;
 padding: 0 1rem;
 margin: 0 auto;
 border: 0.6rem solid #ED1D23;
 position: relative;
}
.symbol {
 position: absolute;
 color: #ED1D23;
 font-size: 12rem;
 top:-2.5rem;
 left:1.8rem;
}
</style>



// WEBPACK FOOTER //
// Error.vue?6f65ff8e